import { render, staticRenderFns } from "./question-other.vue?vue&type=template&id=d3986eaa&"
import script from "./question-other.vue?vue&type=script&lang=ts&"
export * from "./question-other.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3986eaa')) {
      api.createRecord('d3986eaa', component.options)
    } else {
      api.reload('d3986eaa', component.options)
    }
    module.hot.accept("./question-other.vue?vue&type=template&id=d3986eaa&", function () {
      api.rerender('d3986eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/question-other.vue"
export default component.exports